/* eslint-disable jsx-a11y/accessible-emoji */
import {Trans} from '@lingui/macro';
import React, {FC, useContext, useEffect} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../libs/shared/ui/src/styles/fontStyles';
import {boxShadow} from '../../../libs/shared/ui/src/theme/themeStyleHelpers';
import {openInBrowser} from '../../../srcCommon/browser/openInBrowser';
import guestLogo from '../../assets/images/guestLogo.svg';
import {useMeasureElement} from '../../helpers/hooks/domHookHelpers';
import {GrammarlyContext} from '../grammarly/grammarlyContext';
import {VisitorViewerSidebarContent} from './visitorViewerSidebarContent';

/*
 * Style.
 */

const StyledSidebarDiv = styled.div`
  display: grid;
  grid-template-rows: auto 1fr auto;
  justify-items: center;
  align-items: center;
  height: 100%;
  width: 400px;
  min-width: 320;
  ${(p) => boxShadow(p.theme, `0 0 20px ${p.theme.alphas.gray20}`)};
  background-color: ${(p) => p.theme.greys.white};
`;

const StyledLogoDiv = styled.div`
  padding: 30px 0;

  img {
    max-height: 82px;
  }
`;

const StyledFooterDiv = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: 20px;

  padding: 26px 0;
`;

const StyledLinkDiv = styled.div`
  cursor: pointer;
  color: ${(p) => p.theme.greys.shade60};
  font-size: ${fontSizes.verySmall};
  font-weight: ${fontWeights.medium};

  &:hover {
    color: ${(p) => p.theme.greys.shade70};
  }
`;

/*
 * Component.
 */

export const VisitorViewerSidebar: FC = () => {
  const [sidebarRef, {width: sidebarWidth}] = useMeasureElement();
  const {setRightSidebarWidth} = useContext(GrammarlyContext);
  useEffect(() => {
    setRightSidebarWidth(sidebarWidth);
  }, [setRightSidebarWidth, sidebarWidth]);

  return (
    <StyledSidebarDiv ref={sidebarRef}>
      <StyledLogoDiv>
        <img alt="Front Logo" src={guestLogo} />
      </StyledLogoDiv>
      <VisitorViewerSidebarContent />
      <StyledFooterDiv>
        <StyledLinkDiv onClick={onWhatsFrontClick}>
          <Trans id="visitor-sidebar-whatsfront">What&#39;s Front?</Trans>
        </StyledLinkDiv>
        <StyledLinkDiv onClick={onContactUsClick}>
          <Trans id="visitor-sidebar-contactus">Contact us</Trans>
        </StyledLinkDiv>
      </StyledFooterDiv>
    </StyledSidebarDiv>
  );
};

/*
 * Event handlers.
 */

function onWhatsFrontClick() {
  openInBrowser('https://www.frontapp.com?utm_source=front&utm_campaign=share_thread_p3');
}

function onContactUsClick() {
  openInBrowser('mailto:team@frontapp.com');
}
